import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { ContactActions } from './contact.actions';
import { IContactState } from './contact.state';

export const initialContactState: IContactState = {
  model: undefined,
  data: undefined,
  clubMembership: undefined,
  uiState: undefined
};

const actions = new ContactActions();

const contactReducerFn = createReducer(
  initialContactState,
  on(ContactActions.reset, (state: IContactState, action) => {
    return new StateBuilder<IContactState>(initialContactState).build();
  }),
  on(ContactActions.updateModel, (state: IContactState, action) => {
    return new StateBuilder<IContactState>(state, action).build();
  }),
  on(ContactActions.updateClubMembership, (state: IContactState, action) => {
    const { hidden, required } = action.modelState;

    return new StateBuilder<IContactState>(state, {
      clubMembership: { hidden, required }
    })
      .toLoading()
      .build();
  }),
  on(ContactActions.load, (state: IContactState, action) => {
    return new StateBuilder<IContactState>(state).toLoading().build();
  }),
  on(ContactActions.loadSuccess, (state: IContactState, action) => {
    return new StateBuilder<IContactState>(state, action).toLoaded().build();
  }),
  on(ContactActions.loadFailure, (state: IContactState, error) => {
    return new StateBuilder<IContactState>(state).toError(error).build();
  }),
  on(ContactActions.submit, (state: IContactState, action) => {
    return new StateBuilder<IContactState>(state).toLoading().build();
  }),
  on(ContactActions.submitSuccess, (state: IContactState, action) => {
    return new StateBuilder<IContactState>(state, action).toLoaded().build();
  })
);

export function contactReducer(state: IContactState | undefined, action: Action) {
  return contactReducerFn(state, action);
}

// export const makeReducer = <T extends IFeatureState<unknown, unknown>>(initiateState: T, actions: ReducerActions) => {
//   return createReducer(
//     initiateState,
//     on(actions.reset, <T>(state: T,  {...action }) => {
//       // state = { ...state , ...initiateState };
//       return new StateBuilder<T>(state).build();
//     }),
//     on(actions.load, <E>(state: E, {...action }) => {
//       return new StateBuilder<E>(state).toLoading().build();
//     }),
//     on(actions.loadSuccess, <T>(state: T,  {...action }) => {
//       return new StateBuilder<T>(state, action).toLoading().build();
//     }),
//     on(actions.loadFailure, <T>(state: T,  {...error }) => {
//       return new StateBuilder<T>(state).toError(error).build();
//     }),
//     on(actions.submit, <T>(state: T, {...action }) => {
//       return new StateBuilder<T>(state).toLoading().build();
//     }),
//     on(actions.submitSuccess, <T>(state: T,  {...action }) => {
//       return new StateBuilder<T>(state, action).toLoading().build();
//     }),
//     on(actions.submitFailure, <T>(state: T,  {...error }) => {
//       return new StateBuilder<T>(state).toError(error).build();
//     })
//   )
// }
